import React from 'react';

import AccountManagerService from '../../services/Celcoin/accountManagerService';
import { getTranslations } from '../../services/languageUtils';

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      movements: [
        // {
        //   "id": "aa99877c-6205-45ce-8fd8-18173fdd782a",
        //   "clientCode": "7a2a4ea2-ee65-4b3d-8e1d-311dd45d3017",
        //   "description": "Recebimento Pix",
        //   "createDate": "2022-08-31T17:19:55",
        //   "lastUpdateDate": "2022-08-31T17:19:55",
        //   "amount": 10.12,
        //   "status": "Saldo Liberado",
        //   "balanceType": "CREDIT",
        //   "movementType": "PIXPAYMENTIN"
        // }
      ],
      translations: {}
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
    this.refresh();
  }

  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  formatDateTime(input) {
    const date = new Date(input);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${day}/${month} - ${hours}:${minutes}:${seconds}`;
  }  
  
  getDate(type) {
    const today = new Date();
    let date;
  
    if (type === 'today') {
      date = today;
    } else if (type === 'sixDaysAgo') {
      date = new Date();
      date.setDate(today.getDate() - 6);
    } else {
      throw new Error("Invalid type. Use 'today' or 'sixDaysAgo'.");
    }
  
    return this.formatDate(date);
  }

  refresh() {
    let that = this;
    AccountManagerService.showMovement({
      dateFrom: this.getDate('sixDaysAgo'),
      dateTo: this.getDate('today')
    }).then((res) => {
      that.setState({movements: res.data.body.movements});
    }).catch((err) => {
      that.setState({movements: []});
      console.error(err);
    });
  }

  render() {
    return (
      <section className="LastTransactionsComponent" id="LastTransactionsComponent">
        <div className="title">
          {this.state.translations.latest_pix_transactions}
        </div>

        <div className="contentMoviments">
          {
            this.state.movements.length > 0 &&
            <div className="contentSubMoviments">
            {
              this.state.movements.map( (movement) =>
                <div key={movement.id}>
                  {
                    movement.balanceType !== "CREDIT" &&
                    <img src={require("../../assets/imgs/movim-enviar.svg").default} alt={this.state.translations.icon_higher} className="iconMoviment"/>
                  }
                  {
                    movement.balanceType === "CREDIT" &&
                    <img src={require("../../assets/imgs/movim-receber.svg").default} alt={this.state.translations.icon_higher} className="iconMoviment"/>
                  }
                  <div className="contentMoviment">
                    <p className="t1">
                      {this.formatDateTime(movement.createDate)}
                    </p>
                    <p className="t2">
                      <b>{movement.movementType.toLowerCase()}</b>
                    </p>
                  </div>
                  <div className="contentBRL">
                    {movement.amount.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}
                  </div>
                </div>
              )
            }
            </div>
          }
          {
            this.state.movements.length === 0 &&
            <span>
              <center>{this.state.translations.no_records_found}</center>
            </span>
          }
        </div>
      </section>
    );
  }
}

export default Item;
